<template>
  <div class="musiclibrary spotify-playlists container-fluid">
    <div class="container-fluid">
      <div class="row" id="">
        <div class="col-md-12">
          <b-card no-body id="musicLibrarySpotifyCard" class="p-3 mt-0 mx-1">
            <b-card-body class="p-md-3 pt-md-0 p-0 pt-3">
              <dataset :datasetI18n="datasetI18n" v-slot="{ ds }" :ds-data="playlists_list" :ds-filter-fields="{
                title: startsWithFilter,
              }" :ds-search-in="['title']" :ds-search-as="{ searchTest }">
                <div class="row mb-2" :data-page-count="ds.dsPagecount">
                  <div class="col-xl-7 col-md-6">
                    <b-input-group class="" v-bind:class="{
                      'input-group-search-doomyoga': client_name == 'DY',
                      'input-group-search-mid': client_name == 'MID',
                    }">
                      <template #prepend>
                        <font-awesome-icon icon="fa-solid fa-magnifying-glass" size="lg" />
                      </template>
                      <dataset-search ds-search-placeholder="Search" v-bind:class="{
                        'form-control-doomyoga': client_name == 'DY',
                        'form-control-mid': client_name == 'MID',
                      }" /></b-input-group>
                  </div>

                  <div class="col-xl-3 col-md-6 px-md-0 px-3 addButtonContainerDiv">
                    <b-button variant="doomyoga-primary" id="" class="btn btn-bumblebee m-0" v-bind:class="{
                      'btn-doomyoga btn-filter btn-doomyoga-primary':
                        client_name == 'DY',
                      'btn-mid btn-filter btn-mid-primary ':
                        client_name == 'MID',
                    }" @click="clickAddPlaylist">
                      + Add New
                    </b-button>
                  </div>
                </div>
                <dataset-show class="d-none" :ds-show-entries="12" />

                <div class="row">
                  <div class="col-md-12">
                    <div class="row my-2">
                      <div class="col">
                        <h5 v-bind:class="{
                          'card-subtitle-doom-yoga': client_name == 'DY',
                          'card-subtitle-irish-date': client_name == 'MID',
                        }">
                          {{ title }}
                        </h5>
                      </div>
                    </div>
                    <dataset-item class="row mb-3">
                      <template #default="{ row }">
                        <div class="
                                                            col-xl-2 col-lg-3 col-md-3 col-6
                                                            mb-4
                                                            px-md-3 px-2
                                                          ">
                          <router-link :to="
                            '/' +
                            client_name_to +
                            '/music_library/spotify_playlist/' +
                            row.id
                          " class="card-link eventLink">
                            <MediaCard class="media-card-item" v-bind:class="{
                              'media-card-item-dy': client_name == 'DY',
                              'media-card-item-mid': client_name == 'MID',
                            }" :title="row.title" :duration="row.duration" :img_src="row.cover" media_type="music"
                              music_type="spotify" :client_name="client_name" />
                          </router-link>
                          <b-row class="my-2" v-if="client_name == 'DY'"><b-col>
                              <b-button-group class="
                                                                d-block
                                                                text-center
                                                                btn-group-actions-doomyoga
                                                              ">
                                <b-button variant="doomyoga-primary" size="sm" @click="
                                  clickEditCategory(
                                    row.id,
                                    row.title,
                                    row.playlist_id
                                  )
                                ">Edit</b-button>
                                <b-button variant="doomyoga-info" size="sm"
                                  @click="clickDeleteCategory(row.id)">Delete</b-button></b-button-group></b-col></b-row>
                        </div>
                      </template>
                      <template #noDataFound>
                        <div class="col-md-12 pt-2">
                          <p class="text-center datasetNoFoundP" v-bind:class="{
                            noDataFoundDY: client_name == 'DY',
                            noDataFoundMID: client_name == 'MID',
                          }">
                            No data found
                          </p>
                        </div>
                      </template>
                    </dataset-item>
                  </div>
                </div>
                <div class="
                                                    d-flex
                                                    flex-md-row flex-column
                                                    justify-content-between
                                                    align-items-center
                                                  ">
                  <dataset-info class="mb-2 datasetInfo" v-bind:class="{
                    datasetInfoDY: client_name == 'DY',
                    datasetInfoMID: client_name == 'MID',
                  }" />
                  <dataset-pager v-bind:class="{
                    datasetPagerDY: client_name == 'DY',
                    datasetPagerMID: client_name == 'MID',
                  }" />
                </div>
              </dataset>
            </b-card-body>
          </b-card>
        </div>
      </div>
      <!-- add playlist modal -->

      <b-modal id="saveSpotifyPlaylistModal" :modal-class="
        client_name == 'DY' ? 'modal-doom-yoga' : 'modal-irish-date'
      " centered hide-footer>
        <template #modal-title> {{ modal_title }} {{ selected_playlist_id }} </template><b-form
          @submit.prevent="onSubmit">
          <b-row class="mt-3">
            <b-col md="12">
              <b-form-group label="Playlist category title" label-for="playlist_title" :label-class="{
                'form-label-doomyoga': client_name == 'DY',
                'form-label-mid': client_name == 'MID',
              }" :playlist_title="playlist_title">
                <b-form-input id="playlist_title" v-bind:class="{
                  'form-control-doomyoga': client_name == 'DY',
                  'form-control-mid': client_name == 'MID',
                }" v-model="playlist_title" :playlist_title="playlist_title" required></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group label="Upload playlist URL" label-for="playlist_url" :label-class="{
                'form-label-doomyoga': client_name == 'DY',
                'form-label-mid': client_name == 'MID',
              }" :playlist_url="playlist_url">
                <b-form-input id="playlist_url" v-bind:class="{
                  'form-control-doomyoga': client_name == 'DY',
                  'form-control-mid': client_name == 'MID',
                }" v-model="playlist_url" :playlist_url="playlist_url" required></b-form-input>
              </b-form-group>
            </b-col> </b-row><b-row class="mt-4">
            <b-col>
              <b-button type="submit" class="btn-doom-yoga-submit btn-bumblebee float-right" :variant="
                client_name == 'MID' ? 'mid-primary' : 'doomyoga-primary'
              " v-bind:class="{
  'btn-doomyoga  btn-doom-yoga-submit': client_name == 'DY',
  'btn-mid btn-mid-submit': client_name == 'MID',
}" v-if="!is_loading">
                Save
              </b-button>
              <b-button type="button" disabled class="btn-doom-yoga-submit btn-bumblebee float-right" :variant="
                client_name == 'MID' ? 'mid-primary' : 'doomyoga-primary'
              " v-bind:class="{
  'btn-doomyoga  btn-doom-yoga-submit': client_name == 'DY',
  'btn-mid btn-mid-submit': client_name == 'MID',
}" v-else>
                <b-spinner small label="Small Spinner" variant="light"></b-spinner>
                Loading
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-modal>

      <!-- delete modal-->
      <b-modal id="deleteSpotifyPlaylistModal" centered modal-class="modal-doom-yoga">
        <div class="d-block mb-4">


          <input id="client" name="client" type="hidden" v-model="client_name" />

          <p class="confirmMessageModalP message-modal-dy my-4">
            Are you sure you want to delete this playlist?
          </p>
        </div>
        <template class="justify-content-center mt-5" #modal-footer>
          <b-row class="justify-content-center w-100">
            <b-col lg="4" md="6" class="text-center">
              <b-button type="button" variant="doomyoga-primary"
                class="w-100 btn-bumblebee btn-doomyoga btn-doom-yoga-submit" v-if="!is_loading"
                @click="clickConfirmDelete">
                Yes
              </b-button>
              <b-button type="button" disabled variant="doomyoga-primary"
                class="btn-bumblebee btn-doomyoga btn-doom-yoga-submit w-100" v-else>
                <b-spinner small label="Small Spinner" variant="light"></b-spinner>
                Loading
              </b-button>
            </b-col>

            <b-col lg="4" md="6" class="text-center">
              <b-button type="button" variant="doomyoga-danger-outline"
                class="w-100 btn-bumblebee btn-doomyoga btn-doom-yoga-submit" @click="closeModalDelete">
                Cancel
              </b-button>
            </b-col>
          </b-row>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";
import MediaCard from "../media_components/MediaCard.vue";

import {
  filterList,
  clone,
  isoDateToEuroDate,
  searchAsEuroDate,
} from "vue-dataset/docs/.vuepress/utilities";
import { debounce, fieldFilter, findAny } from "vue-dataset/src/helpers";


import Spotify from "spotify-web-api-node";
var ServerMethods = require("spotify-web-api-node/src/server-methods");
Spotify._addMethods(ServerMethods);

import { convertMsToHMSText } from "@/utils/helper-functions.js";
import { getSpotifyToken, getSpotifyAccessToken } from "@/utils/spotify-functions.js"

export default {
  name: "SpotifyPlaylists",
  props: ["client_name"],
  components: { MediaCard },
  data() {
    return {
      client_name_to: this.client_name == "DY" ? "doom_yoga" : "my_irish_date",
      title: "Spotify Playlists ",
      playlists_list: [
      ],
      selected_playlist_id: null,

      onlineFilter: "",
      selected: 12,
      startsWith: "",
      datasetI18n: {
        show: "Show",
        entries: "entries",
        previous: "<",
        next: ">",
        showing: "Showing",
        showingTo: "to",
        showingOf: "of",
        showingEntries: "entries",
      },
      playlist_title: null,
      playlist_url: null,
      playlist_cover_image: null,
      playlist_duration: null,
      is_loading: false,
      playlist_id: null,
      spotifyApi: null,
      authorizeURL: null,

      client_id: "",
      client_secret: "",

      modal_title: "Add New Playlist"

      // let CLIENT_ID_MID = "fe25061a9f104a99a1ebb3509bccd460";
      // let CLIENT_SECRET_MID = "54a0f544c0bc4dc0854af0d0b30df206";
    };
  },

  mounted() {
    this.getSpotifyToken(this.client_name)
    this.spotifyApi = new Spotify();
    this.spotifyApi.setAccessToken(
      localStorage.getItem("spotify_access_token")
    );

    // alert(this.client_id)
    // this.spotifyApi = getSpotifyApi();
    // this.spotifyApi.setAccessToken(token);
    // console.log(this.spotifyApi);
    // // console.log(token)
    // // https://accounts.spotify.com:443/authorize?client_id=5fe01282e44241328a84e7c5cc169165&response_type=code&redirect_uri=https://example.com/callback&scope=user-read-private%20user-read-email&state=some-state-of-my-choice

    console.log(new Date());
    console.log(Date.now());
    console.log(localStorage);

    let temp = this

    // alert(this.authorizeURL)
    //   this.getSpotifyAccessToken(false);

    this.getPlaylistsList();
  },
  created() {
    this.startWithInput = debounce((e) => {
      this.startsWith = e.target.value;
    }, 100);
  },
  methods: {
    getSpotifyToken, getSpotifyAccessToken,
    getPlaylistsList() {
      console.log("in get playlists list ", this.client_name);
      axios
        .get("social/admin/playlists", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          console.log(response.data);
          this.playlists_list = response.data.data;
        });
    },
    filterList,
    isoDateToEuroDate,
    searchAsEuroDate,
    // updateData() {
    //   const updatedList = clone(playlists_list).slice(5, 5);
    //   this.playlists_list = updatedList;
    // },
    startsWithFilter(value) {
      return (
        value === null ||
        value.toLowerCase().startsWith(this.startsWith.toLowerCase())
      );
    },
    searchTest(value, searchString, rowData) {
      console.log(value);
      console.log(searchString);
      console.log(rowData);
      console.log(searchString === value);
      return searchString === value;
    },
    fieldFilter,

    async onSubmit(event) {
      console.log(event);
      console.log(this.playlist_title);
      console.log(this.playlist_url);

      const urlObj = new URL(this.playlist_url);

      urlObj.search = '';
      urlObj.hash = '';

      this.playlist_url = urlObj.toString()

      console.log(/[^/]*$/.exec(this.playlist_url)[0]);
      this.is_loading = true;

      this.playlist_id = /[^/]*$/.exec(this.playlist_url)[0];

      console.log("======> ", localStorage.getItem("spotify_access_token"))

      await this.getSpotifyAccessToken();
      this.spotifyApi.setAccessToken(
        localStorage.getItem("spotify_access_token")
      );
      console.log("api")
      this.getPlaylistData(this.playlist_id)
      // this.getSpotifyAccessToken(true);
    },
    getPlaylistData(playlist_id) {

      var temp = this;
      console.log(playlist_id)
      // return
      this.spotifyApi.getPlaylist(playlist_id).then(
        function (data) {
          console.log("Some information about this playlist");
          console.log(data.body);
          console.log(data.body.images[0].url);
          var duration = 0;
          var tracks = data.body.tracks.items;
          for (var i = 0; i < tracks.length; i++) {
            duration += tracks[i].track.duration_ms;
          }
          console.log(duration);
          console.log(duration / 1000 / 60);
          console.log(duration / 1000 / 60 / 60);
          console.log(convertMsToHMSText(duration));
          console.log(tracks);

          temp.playlist_cover_image = data.body.images[0].url;
          temp.playlist_duration = convertMsToHMSText(duration);
          temp.sendSavePlaylistRequest();
          // temp.is_loading = false;
        },
        function (err) {
          console.log("Something went wrong!", err);
        }
      );
    },
    sendSavePlaylistRequest(title, playlist_id) {
      console.log("in send add playlist request ");
      console.log(
        this.playlist_title,
        this.playlist_id,
        this.playlist_duration,
        this.playlist_cover_image
      );
      let temp = this

      let formData = new FormData();
      formData.append("client", this.client_name);
      formData.append("title", this.playlist_title);
      formData.append("playlist_id", this.playlist_id);
      formData.append("cover", this.playlist_cover_image);
      formData.append("duration", this.playlist_duration);
      formData.append("provider", "spotify");
      if (this.selected_playlist_id != null) {
        console.log("before send edit request")

        formData.append("_method", "put")

        axios
          .post("social/admin/playlists/" + this.selected_playlist_id, formData, {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization:
                "Bearer " +
                JSON.parse(window.localStorage.getItem("user")).access_token,
            },
          })
          .then((response) => {
            console.log(response);
            this.$fire({
              // title: "Title",
              text: "Playlist is updated successfully",
              type: "success",
              timer: 3000,
              customClass: {
                container: this.swal_container_class,
                confirmButton: this.swal_confirm_button_class,
              },
            }).then((r) => {
              // console.log(r.value);
            });
            temp.is_loading = false;
            temp.$bvModal.hide("saveSpotifyPlaylistModal");
            temp.getPlaylistsList();
          })
          .catch((error) => {
            console.log(error.response);
            this.is_loading = false;
            this.$fire({
              // title: "Title",
              text: error.response.data.error,
              type: "error",
              // timer: 3000,
              customClass: {
                container: this.swal_container_class,
                confirmButton: this.swal_confirm_button_class,
              },
            }).then((r) => {
              // console.log(r.value);
            });
          });

      } else {
        console.log("before send add request")

        axios
          .post("social/admin/playlists", formData, {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization:
                "Bearer " +
                JSON.parse(window.localStorage.getItem("user")).access_token,
            },
          })
          .then((response) => {
            console.log(response);
            this.$fire({
              // title: "Title",
              text: "Playlist is created successfully",
              type: "success",
              timer: 3000,
              customClass: {
                container: this.swal_container_class,
                confirmButton: this.swal_confirm_button_class,
              },
            }).then((r) => {
              // console.log(r.value);
            });
            temp.is_loading = false;
            temp.$bvModal.hide("saveSpotifyPlaylistModal");
            temp.getPlaylistsList();
          })
          .catch((error) => {
            console.log(error.response);
            this.is_loading = false;
            this.$fire({
              // title: "Title",
              text: error.response.data.error,
              type: "error",
              // timer: 3000,
              customClass: {
                container: this.swal_container_class,
                confirmButton: this.swal_confirm_button_class,
              },
            }).then((r) => {
              // console.log(r.value);
            });
          });
      }

    },
    clickAddPlaylist() {
      console.log("click add playlist")
      this.selected_playlist_id = null
      this.modal_title = "Add New Playlist"
      this.playlist_title = ""
      this.playlist_url = ""

      this.$root.$emit("bv::show::modal", "saveSpotifyPlaylistModal");

    },
    clickDeleteCategory(id) {
      console.log("click delete category", id);
      this.selected_playlist_id = id;

      this.$root.$emit("bv::show::modal", "deleteSpotifyPlaylistModal");
    },
    clickConfirmDelete() {
      console.log(
        "in confirm delete category ",
        this.client_name,
        this.category_id
      );
      // return;
      this.is_loading = true;
      let temp = this
      axios
        .delete(
          "social/admin/playlists/" + this.selected_playlist_id,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              client: this.client_name,
              Authorization:
                "Bearer " +
                JSON.parse(window.localStorage.getItem("user")).access_token,
            },
          }
        )
        .then((response) => {
          console.log(response);
          this.is_loading = false;
          let success_message = response.data.success

          this.$fire({
            // title: "Title",
            text: success_message,
            type: "success",
            // timer: 5000,
          }).then((r) => {
            this.$bvModal.hide("deleteSpotifyPlaylistModal");
            temp.getPlaylistsList();
          });

          // console.log("test3")
        })
        .catch((error) => {
          // console.log(error.response.data.error);
          // console.log(error.request);
          // console.log(error.message);
          this.is_loading = false;
          let error_message = error.response.data.error


          this.$fire({
            // title: "Title",
            text: error_message,
            type: "error",
            // timer: 5000,
          }).then((r) => {
          });
        });
    },
    closeModalDelete() {
      this.$bvModal.hide("deleteSpotifyPlaylistModal");
    },
    clickEditCategory(id, title, playlist_id) {
      console.log("click edit playlist", id, title, playlist_id)
      this.selected_playlist_id = id
      this.modal_title = "Playlist Info"
      this.playlist_title = title
      this.playlist_url = 'https://open.spotify.com/playlist/' + playlist_id

      this.$root.$emit("bv::show::modal", "saveSpotifyPlaylistModal");
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/music_library/SpotifyPlaylists.vue